import { createFileRoute, Navigate } from '@tanstack/react-router';

import { TeamsApp } from '@apps/web/components/settings/teams_app';
import { TeamsNotifications } from '@apps/web/components/settings/teams_notifications';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/teams')({
    component: TeamsPage,
});

function TeamsPage() {
    const { organizationId, gates, isLoading } = useSettingsGates();
    if (isLoading) {
        return null;
    }
    if (!gates.canManageOrgSettings || !gates.teams) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Microsoft Teams"
            description="Choose where Phoebe sends notification links in Microsoft Teams."
        >
            <div className="space-y-6">
                <TeamsApp organizationId={organizationId} />
                <details className="rounded-xl border p-5">
                    <summary className="cursor-pointer text-sm font-medium">
                        Use a Teams Workflow instead
                    </summary>
                    <div className="mt-4">
                        <TeamsNotifications
                            key={organizationId}
                            organizationId={organizationId}
                        />
                    </div>
                </details>
            </div>
        </SettingsPageShell>
    );
}
